/*eslint-disable quotes */
/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';

import { Col, Container, Row, Form } from 'react-bootstrap';
import '../configuration.scss';
import './NetworkSettings.scss';
import { setAppConfig } from '../../../../redux/app/appSlice';
import { CreateAdminConfig } from '../../../utils/common';
import { useSelector, useDispatch } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import ToastMessage from '../../common/ToastMessage';
import { axiosInstance } from 'src/api/axios';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import {
  HttpErrorCodes,
  HttpSuccessCodes,
} from '../../../errorhandling/HttpErrorCodes';
import GenericButton from '../../../../Components/GenericButton/GenericButton';
import { HorizontalDivider } from 'src/Admin/components/common/HorizontalDivider';
import RadioInput from '../../common/radio';
import WarningComponent from '../WarningComponent';
import HttpHeader from 'src/Admin/shared/httpheader';

export default function NetworkSettings(props) {
  const { Network_Setting } =
    useSelector((state) => state.app?.appConfigs) || {};
  const cName = HttpHeader.getCNAME();
  const penaltyLabelBasedOnCname =
    cName.includes('keenan') || cName.includes('tpabenefits')
      ? 'Tier: Out of Network'
      : 'Penalty';
  //Coverage
  const [selectedRadioBtnCoverageMember, SetselectedRadioBtnCoverageMember] =
    useState(Network_Setting?.Display_Network_For_Coverage_Member);
  const [valueForCoverageMember, SetvalueForCoverageMember] = useState(
    Network_Setting?.Value_Network_For_Coverage_Member === 'network'
      ? 'Show Network'
      : 'Show Network Tier',
  );
  const [selectedRadioBtnCoverageAdmin, SetselectedRadioBtnCoverageAdmin] =
    useState(Network_Setting?.Display_Network_For_Coverage_Admin);
  const [valueForCoverageAdmin, SetvalueForCoverageAdmin] = useState(
    Network_Setting?.Value_Network_For_Coverage_Admin === 'network'
      ? 'Show Network'
      : 'Show Network Tier',
  );

  const [
    selectedRadioBtnClaimNetworkShowTier,
    SetselectedRadioBtnClaimNetworkShowTier,
  ] = useState(Network_Setting?.Display_Network_Tier_Claim_Details);
  const [selectedRadioBtnPenalty, SetselectedRadioBtnPenalty] = useState(
    Network_Setting?.Display_Penalty_OR_OutOfNetwork,
  );
  //find Provider
  const [
    selectedRadioBtnFindProviderMember,
    SetSelectedRadioBtnFindProviderMember,
  ] = useState(Network_Setting?.Display_Network_For_FindProvider_Member);
  const [valueForFindProviderMember, SetvalueForFindProviderMember] = useState(
    Network_Setting?.Value_Network_For_FindProvider_Member === 'network'
      ? 'Show Network'
      : 'Show Network Tier',
  );
  const [
    selectedRadioBtnFindProviderAdmin,
    SetSelectedRadioBtnFindProviderAdmin,
  ] = useState(Network_Setting?.Display_Network_For_FindProvider_Admin);
  const [valueForFindProviderAdmin, SetvalueForFindProviderAdmin] = useState(
    Network_Setting?.Value_Network_For_FindProvider_Admin === 'network'
      ? 'Show Network'
      : 'Show Network Tier',
  );

  //Price Comparison
  const [
    selectedRadioBtnPriceComparisonMember,
    SetSelectedRadioBtnPriceComparisonMember,
  ] = useState(Network_Setting?.Display_Network_For_PriceComparison_Member);
  const [valueForPriceComparisonMember, SetvalueForPriceComparisonMember] =
    useState(
      Network_Setting?.Value_Network_For_PriceComparison_Member === 'network'
        ? 'Show Network'
        : 'Show Network Tier',
    );
  const [
    selectedRadioBtnPriceComparisonAdmin,
    SetSelectedRadioBtnPriceComparisonAdmin,
  ] = useState(Network_Setting?.Display_Network_For_PriceComparison_Admin);
  const [valueForPriceComparisonAdmin, SetvalueForPriceComparisonAdmin] =
    useState(
      Network_Setting?.Value_Network_For_PriceComparison_Admin === 'network'
        ? 'Show Network'
        : 'Show Network Tier',
    );

  //Cost Estimator
  const [
    SelectedRadioBtnNetworkPriceComparison,
    setSelectedRadioBtnNetworkPriceComparison,
  ] = useState(
    Network_Setting?.Display_Network_Indicator_for_Price_Comparison_page,
  );

  const { appConfigs } = useSelector((state) => state.app) || {};
  const [updatedAppConfigs, setupdatedAppConfigs] = useState(appConfigs);
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);

  const updateNetwork = async () => {
    const saveJson = CreateAdminConfig(updatedAppConfigs);
    console.log('json before updating', saveJson);
    return await axiosInstance.put(
      APIEndpoints.putUpdateConfiguration(),
      JSON.stringify(saveJson),
    );
  };

  //Accumulators
  const [
    selectedRadioBtnAccumulatorsAdmin,
    SetselectedRadioBtnAccumulatorsAdmin,
  ] = useState(Network_Setting?.Display_Network_For_Accumulators_Admin || true);
  const [valueForAccumulatorsAdmin, SetvalueForAccumulatorsAdmin] = useState(
    Network_Setting?.Value_Network_For_Accumulators_Admin != ''
      ? Network_Setting?.Value_Network_For_Accumulators_Admin === 'network'
        ? 'Show Network'
        : 'Show Network Tier'
      : 'Show Network',
  );

  const updateConfig = (
    coverageMember,
    valueForCoverageMember,
    CoverageAdmin,
    valueForCoverageAdmin,
    claimsShowTier,
    selectedRadioBtnPenalty,
    findProviderMember,
    valueForFindProviderMember,
    findProviderAdmin,
    valueForFindProviderAdmin,
    priceComparisonMember,
    valueForPriceComparisonMember,
    priceComparisonAdmin,
    valueForPriceComparisonAdmin,
    networkIndicatorPriceComparison,
    AccumulatorsAdmin,
    valueForAccumulatorsAdmin,
  ) => {
    let showvalueforCMember = '';
    let showvalueforCAdmin = '';

    let showvalueforFPMember = '';
    let showvalueforFPAdmin = '';

    let showvalueforPCMember = '';
    let showvalueforPCAdmin = '';

    let showvalueforAccAdmin = '';

    //Coverage
    if (coverageMember === true) {
      if (valueForCoverageMember === 'Show Network') {
        showvalueforCMember = 'network';
      } else {
        showvalueforCMember = 'tier';
      }
    }
    if (CoverageAdmin === true) {
      if (valueForCoverageAdmin === 'Show Network') {
        showvalueforCAdmin = 'network';
      } else {
        showvalueforCAdmin = 'tier';
      }
    }

    //find provider
    if (findProviderMember === true) {
      if (valueForFindProviderMember === 'Show Network') {
        showvalueforFPMember = 'network';
      } else {
        showvalueforFPMember = 'tier';
      }
    }

    if (findProviderAdmin === true) {
      if (valueForFindProviderAdmin === 'Show Network') {
        showvalueforFPAdmin = 'network';
      } else {
        showvalueforFPAdmin = 'tier';
      }
    }

    //Price Comparison

    if (priceComparisonMember === true) {
      if (valueForPriceComparisonMember === 'Show Network') {
        showvalueforPCMember = 'network';
      } else {
        showvalueforPCMember = 'tier';
      }
    }

    if (priceComparisonAdmin === true) {
      if (valueForPriceComparisonAdmin === 'Show Network') {
        showvalueforPCAdmin = 'network';
      } else {
        showvalueforPCAdmin = 'tier';
      }
    }

    //Accumulators
    if (AccumulatorsAdmin === true) {
      if (valueForAccumulatorsAdmin === 'Show Network') {
        showvalueforAccAdmin = 'network';
      } else {
        showvalueforAccAdmin = 'tier';
      }
    }
    setupdatedAppConfigs((current) => {
      //👇️ using spread syntax (...)
      return {
        ...current,
        Network_Setting: {
          ...current.Network_Setting,

          //👇️ override value for nested country property
          Display_Network_For_Coverage_Member: Boolean(coverageMember),
          Value_Network_For_Coverage_Member: showvalueforCMember,
          Display_Network_For_Coverage_Admin: Boolean(CoverageAdmin),
          Value_Network_For_Coverage_Admin: showvalueforCAdmin,
          Display_Network_For_FindProvider_Member: Boolean(findProviderMember),
          Value_Network_For_FindProvider_Member: showvalueforFPMember,
          Display_Network_For_FindProvider_Admin: Boolean(findProviderAdmin),
          Value_Network_For_FindProvider_Admin: showvalueforFPAdmin,
          Display_Network_For_PriceComparison_Member: Boolean(
            priceComparisonMember,
          ),
          Value_Network_For_PriceComparison_Member: showvalueforPCMember,
          Display_Network_For_PriceComparison_Admin:
            Boolean(priceComparisonAdmin),
          Value_Network_For_PriceComparison_Admin: showvalueforPCAdmin,
          Display_Network_Tier_Claim_Details: Boolean(claimsShowTier),
          Display_Penalty_OR_OutOfNetwork: selectedRadioBtnPenalty,
          Display_Network_Indicator_for_Price_Comparison_page: Boolean(
            networkIndicatorPriceComparison,
          ),
          Display_Network_For_Accumulators_Admin: Boolean(AccumulatorsAdmin),
          Value_Network_For_Accumulators_Admin: showvalueforAccAdmin,
        },
      };
    });
  };

  useEffect(() => {
    updateConfig(
      selectedRadioBtnCoverageMember,
      valueForCoverageMember,
      selectedRadioBtnCoverageAdmin,
      valueForCoverageAdmin,
      selectedRadioBtnClaimNetworkShowTier,
      selectedRadioBtnPenalty,
      selectedRadioBtnFindProviderMember,
      valueForFindProviderMember,
      selectedRadioBtnFindProviderAdmin,
      valueForFindProviderAdmin,
      selectedRadioBtnPriceComparisonMember,
      valueForPriceComparisonMember,
      selectedRadioBtnPriceComparisonAdmin,
      valueForPriceComparisonAdmin,
      SelectedRadioBtnNetworkPriceComparison,
      selectedRadioBtnAccumulatorsAdmin,
      valueForAccumulatorsAdmin,
    );
  }, [
    selectedRadioBtnCoverageMember,
    valueForCoverageMember,
    selectedRadioBtnCoverageAdmin,
    valueForCoverageAdmin,
    selectedRadioBtnClaimNetworkShowTier,
    selectedRadioBtnPenalty,
    selectedRadioBtnFindProviderMember,
    valueForFindProviderMember,
    selectedRadioBtnFindProviderAdmin,
    valueForFindProviderAdmin,
    selectedRadioBtnPriceComparisonMember,
    valueForPriceComparisonMember,
    selectedRadioBtnPriceComparisonAdmin,
    valueForPriceComparisonAdmin,
    SelectedRadioBtnNetworkPriceComparison,
    selectedRadioBtnAccumulatorsAdmin,
    valueForAccumulatorsAdmin,
  ]);

  const handleSubmit = async () => {
    try {
      const response = await updateNetwork();
      console.log('Response ad admin config', response);
      if (HttpSuccessCodes.HTTP_SUCCESS_CODE_200 === response.status) {
        dispatch(setAppConfig(updatedAppConfigs));
      }
      toast.success(
        <ToastMessage
          type="success"
          subTitle={'Updated Network Settings successfully'}
        />,
      );
    } catch (error) {
      console.log(error);
      if (error.toString().includes('409')) {
        toast.warning(
          <ToastMessage
            type="warning"
            subTitle={
              'No changes were made! Select another Network settings and try again.'
            }
          />,
        );
      } else {
        toast.error(
          <ToastMessage
            type="error"
            subTitle={'Network settings updation failed'}
          />,
        );
      }
    }
  };
  return (
    <div>
      <Container className="network-settings mtop30 activationCode m-0">
        <Form>
          <div className="parent-div">
            <h2>Network Settings</h2>
          </div>
          <div className="my-4">
            <WarningComponent />
          </div>
          <Row>
            <Col md={10} lg={10} sm={10}>
              <Row className="mb-3">
                <Col>
                  {' '}
                  <Form.Label className="text-format">
                    <h4>Network filter for Coverages on the Member Portal</h4>
                  </Form.Label>
                </Col>
              </Row>
              <Form.Group
                controlId="formBasicDateFormat"
                className="timezone-margin mb-4"
              >
                <Form.Label
                  className="text-format mb-3"
                  for="coverageformember"
                >
                  <Form.Check
                    type="checkbox"
                    id="coverageformember"
                    checked={selectedRadioBtnCoverageMember}
                    onChange={(e) =>
                      SetselectedRadioBtnCoverageMember(
                        !selectedRadioBtnCoverageMember,
                      )
                    }
                  />
                  <h5>Display Network For Coverage in the Member Portal</h5>
                </Form.Label>

                {selectedRadioBtnCoverageMember === true && (
                  <Row>
                    <div className="network-radio ml-1 mb-4">
                      <RadioInput
                        id="Show_Network1"
                        label="Show Network"
                        name="Show_Network"
                        value="Show Network"
                        checked={'Show Network' === valueForCoverageMember}
                        onChange={(e) =>
                          SetvalueForCoverageMember(e.target.value)
                        }
                      />
                      <RadioInput
                        id="Show_Network2"
                        label="Show Network Tier"
                        name="Show_Network"
                        value="Show Network Tier"
                        checked={'Show Network Tier' === valueForCoverageMember}
                        onChange={(e) =>
                          SetvalueForCoverageMember(e.target.value)
                        }
                      />
                    </div>
                  </Row>
                )}
                <Row className="mb-3">
                  <Col>
                    {' '}
                    <Form.Label className="text-format">
                      <h4>Network filter for Coverages on the Admin Portal</h4>
                    </Form.Label>
                  </Col>
                </Row>
                <Form.Label className="text-format mb-3" for="coverageforadmin">
                  <Form.Check
                    type="checkbox"
                    id="coverageforadmin"
                    checked={selectedRadioBtnCoverageAdmin}
                    onChange={(e) =>
                      SetselectedRadioBtnCoverageAdmin(
                        !selectedRadioBtnCoverageAdmin,
                      )
                    }
                  />
                  <h5>Display Network For Coverage in Admin Center</h5>
                </Form.Label>
                {true === selectedRadioBtnCoverageAdmin && (
                  <Row>
                    <div className="network-radio ml-1 mb-4">
                      <RadioInput
                        id="Show_Network_Admin1"
                        label="Show Network"
                        name="Show_Network_Admin"
                        value="Show Network"
                        checked={'Show Network' === valueForCoverageAdmin}
                        onChange={(e) =>
                          SetvalueForCoverageAdmin(e.target.value)
                        }
                      />
                      <RadioInput
                        id="Show_Network_Admin2"
                        label="Show Network Tier"
                        name="Show_Network_Admin"
                        value="Show Network Tier"
                        checked={'Show Network Tier' === valueForCoverageAdmin}
                        onChange={(e) =>
                          SetvalueForCoverageAdmin(e.target.value)
                        }
                      />
                    </div>
                  </Row>
                )}

                <HorizontalDivider className="mb-4" />

                {/*Find provider configuration */}
                <Row className="mb-3">
                  <Col>
                    {' '}
                    <Form.Label className="text-format">
                      <h4>
                        Network filter for Find Provider on the Member Portal
                      </h4>
                    </Form.Label>
                  </Col>
                </Row>
                <Form.Label
                  className="text-format mb-3"
                  for="findprovidermember"
                >
                  <Form.Check
                    type="checkbox"
                    id="findprovidermember"
                    checked={selectedRadioBtnFindProviderMember}
                    onChange={(e) =>
                      SetSelectedRadioBtnFindProviderMember(
                        !selectedRadioBtnFindProviderMember,
                      )
                    }
                  />
                  <h5>
                    Display Network filter for Find Provider on the Member
                    Portal
                  </h5>
                </Form.Label>
                {selectedRadioBtnFindProviderMember === true && (
                  <Row>
                    <div className="network-radio ml-1 mb-4">
                      <RadioInput
                        id="Show_Network_FP1"
                        label="Show Network"
                        name="Show_Network_FP"
                        value="Show Network"
                        checked={'Show Network' === valueForFindProviderMember}
                        onChange={(e) =>
                          SetvalueForFindProviderMember(e.target.value)
                        }
                      />
                      <RadioInput
                        id="Show_Network_FP2"
                        label="Show Network Tier"
                        name="Show_Network_FP"
                        value="Show Network Tier"
                        checked={
                          'Show Network Tier' === valueForFindProviderMember
                        }
                        onChange={(e) =>
                          SetvalueForFindProviderMember(e.target.value)
                        }
                      />
                    </div>
                  </Row>
                )}

                <Row className="mb-3">
                  <Col>
                    {' '}
                    <Form.Label className="text-format">
                      <h4>
                        Network filter for Find Provider on the Admin Portal
                      </h4>
                    </Form.Label>
                  </Col>
                </Row>
                <Form.Label
                  className="text-format mb-3"
                  for="findprovideradmin"
                >
                  <Form.Check
                    type="checkbox"
                    id="findprovideradmin"
                    checked={selectedRadioBtnFindProviderAdmin}
                    onChange={(e) =>
                      SetSelectedRadioBtnFindProviderAdmin(
                        !selectedRadioBtnFindProviderAdmin,
                      )
                    }
                  />
                  <h5>
                    Display Network filter for Find Provider on the Admin Portal
                  </h5>
                </Form.Label>
                {selectedRadioBtnFindProviderAdmin === true && (
                  <Row>
                    <div className="network-radio ml-1 mb-4">
                      <RadioInput
                        id="Show_Network_FP_admin1"
                        label="Show Network"
                        name="Show_Network_FP_admin"
                        value="Show Network"
                        checked={'Show Network' === valueForFindProviderAdmin}
                        onChange={(e) =>
                          SetvalueForFindProviderAdmin(e.target.value)
                        }
                      />
                      <RadioInput
                        id="Show_Network_FP_admin2"
                        label="Show Network Tier"
                        name="Show_Network_FP_admin"
                        value="Show Network Tier"
                        checked={
                          'Show Network Tier' === valueForFindProviderAdmin
                        }
                        onChange={(e) =>
                          SetvalueForFindProviderAdmin(e.target.value)
                        }
                      />
                    </div>
                  </Row>
                )}

                <HorizontalDivider className="mb-4" />

                {/*Price Comparison configuration */}
                <Row className="mb-3">
                  <Col>
                    {' '}
                    <Form.Label className="text-format">
                      <h4>
                        Network filter for Price Comparison on the Member Portal
                      </h4>
                    </Form.Label>
                  </Col>
                </Row>
                <Form.Label
                  className="text-format mb-3"
                  for="pricecomparisonmember"
                >
                  <Form.Check
                    type="checkbox"
                    id="pricecomparisonmember"
                    checked={selectedRadioBtnPriceComparisonMember}
                    onChange={(e) =>
                      SetSelectedRadioBtnPriceComparisonMember(
                        !selectedRadioBtnPriceComparisonMember,
                      )
                    }
                  />
                  <h5>
                    Display Network filter for Price Comparison on the Member
                    Portal
                  </h5>
                </Form.Label>
                {selectedRadioBtnPriceComparisonMember === true && (
                  <Row>
                    <div className="network-radio ml-1 mb-4">
                      <RadioInput
                        id="Show_Network_PC1"
                        label="Show Network"
                        name="Show_Network_PC"
                        value="Show Network"
                        checked={
                          'Show Network' === valueForPriceComparisonMember
                        }
                        onChange={(e) =>
                          SetvalueForPriceComparisonMember(e.target.value)
                        }
                      />
                      <RadioInput
                        id="Show_Network_PC2"
                        label="Show Network Tier"
                        name="Show_Network_PC"
                        value="Show Network Tier"
                        checked={
                          'Show Network Tier' === valueForPriceComparisonMember
                        }
                        onChange={(e) =>
                          SetvalueForPriceComparisonMember(e.target.value)
                        }
                      />
                    </div>
                  </Row>
                )}

                <Row className="mb-3">
                  <Col>
                    {' '}
                    <Form.Label className="text-format">
                      <h4>
                        Network filter for Price Comparison on the Admin Portal
                      </h4>
                    </Form.Label>
                  </Col>
                </Row>
                <Form.Label
                  className="text-format mb-3"
                  for="pricecomparisonmember"
                >
                  <Form.Check
                    type="checkbox"
                    id="pricecomparisonmember"
                    checked={selectedRadioBtnPriceComparisonAdmin}
                    onChange={(e) =>
                      SetSelectedRadioBtnPriceComparisonAdmin(
                        !selectedRadioBtnPriceComparisonAdmin,
                      )
                    }
                  />
                  <h5>
                    Display Network filter for Price Comparison on the Admin
                    Portal
                  </h5>
                </Form.Label>
                {selectedRadioBtnPriceComparisonAdmin === true && (
                  <Row>
                    <div className="network-radio ml-1 mb-4">
                      <RadioInput
                        id="Show_Network_PC_admin1"
                        label="Show Network"
                        name="Show_Network_PC_admin"
                        value="Show Network"
                        checked={
                          'Show Network' === valueForPriceComparisonAdmin
                        }
                        onChange={(e) =>
                          SetvalueForPriceComparisonAdmin(e.target.value)
                        }
                      />
                      <RadioInput
                        id="Show_Network_PC_admin2"
                        label="Show Network Tier"
                        name="Show_Network_PC_admin"
                        value="Show Network Tier"
                        checked={
                          'Show Network Tier' === valueForPriceComparisonAdmin
                        }
                        onChange={(e) =>
                          SetvalueForPriceComparisonAdmin(e.target.value)
                        }
                      />
                    </div>
                  </Row>
                )}
                <HorizontalDivider className="mb-4" />
                {/*claims page configuration */}
                <Row className="mb-3">
                  <Col>
                    {' '}
                    <Form.Label className="text-format">
                      <h4>Network tier for Claims Details</h4>
                    </Form.Label>
                  </Col>
                </Row>
                <Form.Label className="text-format mb-3" for="claimsDetails">
                  <Form.Check
                    type="checkbox"
                    id="claimsDetails"
                    checked={selectedRadioBtnClaimNetworkShowTier}
                    onChange={(e) =>
                      SetselectedRadioBtnClaimNetworkShowTier(
                        !selectedRadioBtnClaimNetworkShowTier,
                      )
                    }
                  />
                  <h5>Display Network Tier in Claims Details Page</h5>
                </Form.Label>
                <HorizontalDivider className="mb-4" />
                {/*<Row className="mb-4">
                  <Col>
                    { ' ' }
                    <Form.Label className="text-format">
                      <h4 >
                        Penalty for Coverage
                      </h4>
                    </Form.Label>
                  </Col>
                </Row>
                <Form.Label className="text-format" for="claimsDetails">
                  <Form.Check type="checkbox" id="penalty" checked={ selectedRadioBtnPenalty } onChange={ e => SetselectedRadioBtnPenalty( !selectedRadioBtnPenalty ) } />
                  <h5>Display Penalty in Coverage</h5>
                </Form.Label> */}
                <Form.Label className="text-format mb-3" for="outofnetwork">
                  <h5>Display Out Of Network or Penalty in Coverage</h5>
                </Form.Label>
                {
                  <Row>
                    <div className="network-radio ml-1 mb-4">
                      <RadioInput
                        id="Out-Of-Network-Penalty1"
                        label="Out-Of-Network"
                        name="Out-Of-Network-Penalty"
                        value="Out-Of-Network"
                        checked={'Out-Of-Network' === selectedRadioBtnPenalty}
                        onChange={(e) =>
                          SetselectedRadioBtnPenalty(e.target.value)
                        }
                      />
                      <RadioInput
                        id="Out-Of-Network-Penalty2"
                        label={penaltyLabelBasedOnCname}
                        name="Out-Of-Network-Penalty"
                        value="Penalty"
                        checked={'Penalty' === selectedRadioBtnPenalty}
                        onChange={(e) =>
                          SetselectedRadioBtnPenalty(e.target.value)
                        }
                      />
                    </div>
                  </Row>
                }

                <HorizontalDivider className="mb-4" />
                {/*claims page configuration */}
                <Row className="mb-3">
                  <Col>
                    {' '}
                    <Form.Label className="text-format">
                      <h4>Network Indicator for Price Comparison</h4>
                    </Form.Label>
                    <p className="network_indicator_content">
                      This setting enables the display of the In-network and
                      Out-of-network indicator on the Price Comparison page.
                    </p>
                  </Col>
                </Row>
                <Form.Label className="text-format mb-3" for="networkForPC">
                  <Form.Check
                    type="checkbox"
                    id="networkForPC"
                    checked={SelectedRadioBtnNetworkPriceComparison}
                    onChange={(e) =>
                      setSelectedRadioBtnNetworkPriceComparison(
                        !SelectedRadioBtnNetworkPriceComparison,
                      )
                    }
                  />
                  <h5>Display Network Indicator for Price Comparison page</h5>
                </Form.Label>
              </Form.Group>

              <HorizontalDivider className="mb-4" />
              <Row className="mb-3">
                <Col>
                  {' '}
                  <Form.Label className="text-format">
                    <h4>Network filter for Accumulators on the Admin Portal</h4>
                  </Form.Label>
                </Col>
              </Row>
              <Form.Label className="text-format mb-3" for="coverageforadmin">
                <Form.Check
                  type="checkbox"
                  id="accumulatorsforadmin"
                  checked={selectedRadioBtnAccumulatorsAdmin}
                  onChange={(e) =>
                    SetselectedRadioBtnAccumulatorsAdmin(
                      !selectedRadioBtnAccumulatorsAdmin,
                    )
                  }
                />
                <h5>Display Network For Accumulators in Admin Center</h5>
              </Form.Label>
              {true === selectedRadioBtnAccumulatorsAdmin && (
                <Row>
                  <div className="network-radio ml-1 mb-4">
                    <RadioInput
                      id="Show_Network_Accumulators"
                      label="Show Network"
                      name="Show_Network_Accumulators"
                      value="Show Network"
                      checked={'Show Network' === valueForAccumulatorsAdmin}
                      onChange={(e) =>
                        SetvalueForAccumulatorsAdmin(e.target.value)
                      }
                    />
                    <RadioInput
                      id="Show_Network_Accumulators1"
                      label="Show Network Tier"
                      name="Show_Network_Accumulators"
                      value="Show Network Tier"
                      checked={
                        'Show Network Tier' === valueForAccumulatorsAdmin
                      }
                      onChange={(e) =>
                        SetvalueForAccumulatorsAdmin(e.target.value)
                      }
                    />
                  </div>
                </Row>
              )}
            </Col>
          </Row>
        </Form>
        <Row>
          <Col>
            <GenericButton onClick={handleSubmit} className="ml-1">
              SAVE
            </GenericButton>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
